import { useEffect } from "react";

export const RelationshipisWorship = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div className="modal" style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", overflowY: "auto", zIndex: 1050, }}>
                <div className="modal-content" style={{ padding: "20px", background: "#fff", borderRadius: "8px", maxWidth: "500px", width: "95%", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", maxHeight: "95vh", overflowY: "auto", }}>
                    <div className="img-fluid mb-4">
                        <picture><img src="/media/poemseng/relationship-is-worship.jpg" alt=" Relationship is Worship | Lone Wolf writes " style={{ width: "100%", height: "18rem", objectFit: "cover", borderRadius: "6px", backgroundColor: "gray", }} /></picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>Relationship is Worship</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        You complete my life in ways untold,<br />
                        And I need you by my side,<br />
                        Please, don't let our love grow cold,<br />
                        For without you, there's no pride.<br />
                        <br />
                        Your beauty radiates like a work of art,<br />
                        A masterpiece of grace;<br />
                        I long to hold a special part<br />
                        Inside your heart, my sacred space.<br />
                        <br />
                        I won't let you slip away from me,<br />
                        No matter how hard I must fight;<br />
                        Baby, never say, "Let it be,"<br />
                        I'll move mountains to make things right.<br />
                        <br />
                        For you, I'll do anything,<br />
                        That's the love I vow to show;<br />
                        Just ask, and I'll give you everything,<br />
                        I won't let you down, you’ll always know.<br />
                        <br />
                        I know I’m flawed, I've made mistakes,<br />
                        But I’ll grow for you, I swear;<br />
                        Baby, don’t feel sad or break,<br />
                        You hold the power to heal and repair.<br />
                        <br />
                        Please don’t say, "I'm so done,"<br />
                        You’re the one who has my devotion;<br />
                        In you, I’ve found the only one<br />
                        Worthy of my love, my endless worship and emotion.<br />
                        <br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
